var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApiKeyQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1034 14.546V12.5628C11.1034 11.9163 11.4539 11.5397 12.0344 11.5397H12.3505C13.0458 11.5397 13.4481 11.2448 13.4481 10.5105C13.4481 9.87657 13.0113 9.48117 12.3505 9.48117H10V8H12.5631C13.9768 8 14.9997 8.98536 14.9997 10.5105C15.017 11.8033 14.1722 12.9079 12.8562 12.8891C12.6206 12.8891 12.5516 12.9582 12.5516 13.2092V14.546H11.1034ZM10.9999 17V15.2678H12.6435V17H10.9999Z",
    fill: "#88919A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiKeyQuestion);
export default __webpack_public_path__ + "static/media/apiKeyQuestion.1e00152cc2582a953e1d0abcfba1be70.svg";
export { ForwardRef as ReactComponent };